'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var classnames = require('classnames');
var jobberHooks = require('@jobber/hooks/useResizeObserver');
var styleInject_es = require('../style-inject.es-9d2f5f4e.js');
var Icon = require('../Icon-405a216c.js');
var Text = require('../Text-e7ed0974.js');
var Button = require('../Button-7698424c.js');
require('@jobber/design');
require('../Typography-fd6f932a.js');
require('react-router-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var css_248z$1 = ".meuT8gYQPJU- {\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  box-shadow: 0px calc(16px / 16) calc(16px / 4) 0px\n      rgba(0, 0, 0, 0.1),\n    0px calc(16px / 4) 12px 0px rgba(0, 0, 0, 0.05);\n  box-shadow: var(--shadow-base);\n  padding: calc(16px * 1);\n  padding: var(--space-base);\n  color: rgb(66, 78, 86);\n  color: var(--color-text);\n  background-color: rgb(244, 244, 244);\n  background-color: var(--color-surface--background);\n  gap: calc(16px / 2);\n  gap: var(--space-small);\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n._6v1woNSLEvc- {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  gap: calc(16px / 2);\n  gap: var(--space-small);\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n\n.y4BapyZr-fo- {\n  -ms-flex-item-align: center;\n      align-self: center;\n}\n\n._6v1woNSLEvc- > *:last-child {\n  margin-bottom: 0;\n}\n\n.bocgLmEhcTU- .y4BapyZr-fo- {\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.rtNjEzmABX4- {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n}\n\n.lunQ5SOfyLg- {\n  margin: calc((16px / 8) * -1) 0;\n  margin: calc(calc(16px / 8) * -1) 0;\n  margin: calc(var(--space-smallest) * -1) 0;\n  padding: calc(16px / 8);\n  padding: var(--space-smallest);\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  -webkit-appearance: none;\n          appearance: none;\n  -ms-flex: 0;\n      flex: 0;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n}\n\n.lunQ5SOfyLg-:hover {\n  background: rgba(0, 0, 0, 0.025);\n}\n\n.lunQ5SOfyLg-:focus {\n  box-shadow: 0px 0px calc(16px / 4) calc(16px / 8)\n    rgb(231, 213, 87);\n  box-shadow: var(--shadow-focus);\n  outline: none;\n  background: rgba(0, 0, 0, 0.05);\n}\n";
var styles = {"banner":"meuT8gYQPJU-","bannerContent":"_6v1woNSLEvc-","bannerChildren":"y4BapyZr-fo-","medium":"bocgLmEhcTU-","bannerAction":"rtNjEzmABX4-","closeButton":"lunQ5SOfyLg-"};
styleInject_es.styleInject(css_248z$1);

var css_248z = ".wWW-2T7rCV0- {\n  background-color: rgb(226, 241, 250);\n  background-color: var(--color-informative--surface);\n}\n\n/* Our Banner \"surface\" colors should be lighter than they are so we're leaving the following alone for now */\n\n._7h8FUHIkVjg- {\n  background-color: rgb(203, 223, 159);\n  background-color: var(--color-green--lighter);\n}\n\n.d5fXcE1L0lc- {\n  background-color: rgb(241, 231, 159);\n  background-color: var(--color-yellow--lighter);\n}\n\n.oYaw-T3c0IU- {\n  background-color: rgb(255, 206, 194);\n  background-color: var(--color-red--lighter);\n}\n";
var types = {"notice":"wWW-2T7rCV0-","success":"_7h8FUHIkVjg-","warning":"d5fXcE1L0lc-","error":"oYaw-T3c0IU-"};
styleInject_es.styleInject(css_248z);

function Banner({ children, type, primaryAction, dismissible = true, onDismiss, }) {
    const [showBanner, setShowBanner] = React.useState(true);
    const bannerWidths = {
        small: 320,
        medium: 480,
    };
    const [bannerRef, { width: bannerWidth = bannerWidths.small }] = jobberHooks.useResizeObserver({
        widths: bannerWidths,
    });
    const iconColors = {
        notice: "informative",
        success: "success",
        warning: "warning",
        error: "critical",
    };
    if (primaryAction != undefined) {
        primaryAction = Object.assign({
            size: "small",
            type: "tertiary",
            variation: type === "notice" ? "learning" : "work",
        }, primaryAction);
    }
    const bannerClassNames = classnames__default["default"](styles.banner, types[type], {
        [styles.medium]: bannerWidth >= bannerWidths.medium,
    });
    return (React__default["default"].createElement(React__default["default"].Fragment, null, showBanner && (React__default["default"].createElement("div", { className: bannerClassNames, ref: bannerRef, role: type === "error" ? "alert" : "status" },
        React__default["default"].createElement("div", { className: styles.bannerContent },
            React__default["default"].createElement("div", { className: styles.bannerChildren },
                React__default["default"].createElement(BannerChildren, null, children)),
            primaryAction && (React__default["default"].createElement("div", { className: styles.bannerAction },
                React__default["default"].createElement(Button.Button, Object.assign({}, primaryAction))))),
        dismissible && (React__default["default"].createElement("button", { className: styles.closeButton, onClick: handleClose, "aria-label": "Close this notification" },
            React__default["default"].createElement(Icon.Icon, { name: "cross", color: iconColors[type] })))))));
    function handleClose() {
        setShowBanner(!showBanner);
        onDismiss && onDismiss();
    }
}
function BannerChildren({ children }) {
    if (!children)
        return React__default["default"].createElement(React__default["default"].Fragment, null);
    if (children && typeof children === "string") {
        return React__default["default"].createElement(Text.Text, null, children);
    }
    return React__default["default"].createElement(React__default["default"].Fragment, null, children);
}

exports.Banner = Banner;
